import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import { formatNumber } from "../../../components/formatNumber";

const FarmerInvoiceForm = (props) => {
  const [farmerNo, setFarmerNo] = useState("");
  const [farmerName, setFarmerName] = useState("");
  const [farmersOptions, setFarmersOptions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredFarmers, setFilteredFarmers] = useState([]);
  const [fieldExecutiveName, setFieldExecutiveName] = useState("");
  // const [selectedRanch, setSelectedRanch] = useState("");
  const [selectedPlotId, setSelectedPlotId] = useState("");
  const [selectedFarmerId, setSelectedFarmerId] = useState(null);
  const [plotArea, setPlotArea] = useState("");
  const [plotAreaUnit, setPlotAreaUnit] = useState("");
  const [cropName, setCropName] = useState("");
  const [varietyName, setVarietyName] = useState("");
  const [farmsRanches, setFarmsRanches] = useState([]);
  // const [goodIssueAmount, setGoodIssueAmount] = useState([]);
  const [totalGoodIssueAmount, setTotalGoodIssueAmount] = useState(0);
  const [totalAdministrativeAmount, setTotalAdministrativeAmount] = useState(0);

  const [goodIssueAmount, setGoodIssueAmount] = useState(0);
  const [issueProductResult, setIssueProductResult] = useState([]);
  const [farmerInputTemplateresult, setFarmerInputTemplateresult] = useState(
    []
  );
  const [selectedRanchId, setSelectedRanchId] = useState("");
  const [selectedCropId, setSelectedCropId] = useState("");
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [vehicleOptions1, setVehicleOptions1] = useState([]);
  const [plots, setPlots] = useState([]);
  const [cropId, setCropId] = useState("");
  const [varietyId, setVarietyId] = useState("");
  const [availableCrops, setAvailableCrops] = useState([]);
  const [allowCropAutofill, setAllowCropAutofill] = useState(false);

  const [invoiceData, setInvoiceData] = useState({});

  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [branchName, setBranchName] = useState("");
  const [holderName, setHolderName] = useState("");


  const [badRate, setBadRate] = useState("");
  const [baseRate, setBaseRateName] = useState("");
  const [bonusRate, setBonusRateName] = useState("");
  const [scoreLimit, setScoreLimitName] = useState("");
  const [farmerScore, setFarmerScore] = useState("");
  const [farmerRate, setFarmerRate] = useState("");
  const [farmerList, setFarmerList] = useState([]);

  const getTodayDateString = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // Months start at 0!
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  const [invoiceDate, setInvoiceDate] = useState(getTodayDateString());
  const [isUpdateLoaded, setIsUpdateLoaded] = useState(false);
  const [farmerInput, setFarmerInput] = useState("");
  const frmRef = useRef({});

  const { sendRequest: fetchFarmersList } = useHttp();
  const { sendRequest: fetchRanchesForFarmer } = useHttp();
  const { sendRequest: fetchRanchPlotsForFarmer } = useHttp();
  const { sendRequest: fetchVehicleList } = useHttp();
  const { sendRequest: fetchGoodIssueAmount } = useHttp();
  const { sendRequest: fetchGradeDetails } = useHttp();
  const { sendRequest: fetchFarmerNLCReport } = useHttp();
  const { sendRequest: getHarvestFarmers } = useHttp();



  useEffect(() => {
    getHarvestFarmers(
      {
        url: `/api/harvestFarmerList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res && Array.isArray(res)) {
          const uniqueFarmers = Array.from(
            new Map(res.map((item) => [item.farmerNo, item])).values()
          );
          setFarmerList(uniqueFarmers);
          setFilteredFarmers(uniqueFarmers);
        }
      }
    );
  }, []);



  useEffect(() => {
    if (selectedFarmerId && selectedCropId) {
      fetchFarmerNLCReport(
        {
          url: `/api/farmerNlcReport/?farmerId=${selectedFarmerId}&cropId=${selectedCropId}&orgId=${localStorage.getItem(
            "orgId"
          )}`,
        },
        (res) => {
          if (Array.isArray(res) && res.length > 0) {

            setFarmerScore(res[0].totalScore || 0);
          } else {
            setFarmerScore(0);
          }
        }
      );
    }
  }, [selectedFarmerId, selectedCropId, fetchFarmerNLCReport]);

  useEffect(() => {

    if (selectedCropId) {

      fetchGradeDetails(
        {
          url: `/api/gradeByCropView/?cropId=${selectedCropId}&orgId=${localStorage.getItem("orgId")}`
        },
        (res) => {

          setBaseRateName(res.goodRate || 0)
          setBadRate(res.badRate || 0)
          setBonusRateName(res.bonusRate || 0)
          setScoreLimitName(res.scoreLimit || 0)

        }
      );

    }

  }, [selectedCropId]);
  // useEffect(() => {
  //   fetchFarmersList(
  //     {
  //       url: `/api/farmerDetailList/?orgId=${localStorage.getItem("orgId")}`,
  //     },
  //     (res) => {
  //       if (res && Array.isArray(res)) {
  //         setFarmersOptions(res);

  //         const filtered = res.filter((farmer) => farmer.farmerNo);

  //         setFilteredFarmers(filtered);
  //       }
  //     }
  //   );
  // }, [fetchFarmersList]);

  useEffect(() => {
    if (selectedCropId) {
      fetchVehicleList(
        {
          url: `/api/tableById/?orgId=${localStorage.getItem(
            "orgId"
          )}&cropId=${selectedCropId}`,
        },
        (res) => {
          console.log("tableById", res);
          res = res.map(item => ({

            ...item,

            QtyAdjustment: 0,
            totalAmt: 0,
            FinalQuantity: item.totalQuantity

          }));
          console.log("tableById", res);

          if (res && Array.isArray(res)) {
            setVehicleOptions(res);
          } else {
            setVehicleOptions([]);
          }
        }
      );
    } else {
      setVehicleOptions([]);
    }
  }, [fetchVehicleList, selectedCropId]);

  useEffect(() => {
    if (selectedFarmerId && selectedRanchId) {
      fetchRanchPlotsForFarmer(
        {
          url: `/api/ranchplotById/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerId=${selectedFarmerId}&ranchId=${selectedRanchId}`,
        },
        (data) => {
          setPlots(Array.isArray(data) ? data : []);
        }
      );
    } else {
      setPlots([]);
    }
  }, [selectedFarmerId, selectedRanchId, fetchRanchPlotsForFarmer]);

  // useEffect(() => {
  //   if (selectedCropId && selectedPlotId) {
  //     const filteredVehicleOptions = plots.filter(
  //       (p) =>
  //         String(p.plotIdVal) === String(selectedPlotId) &&
  //         String(p.cropIdVal) === String(selectedCropId)
  //     );
  //     setVehicleOptions(filteredVehicleOptions);
  //   } else {
  //     setVehicleOptions([]);
  //   }
  // }, [selectedCropId, selectedPlotId, plots]);

  useEffect(() => {
    if (!isUpdateLoaded) {
      if (selectedCropId && selectedPlotId) {
        const filteredVehicleOptions = plots.filter(
          (p) =>
            String(p.plotIdVal) === String(selectedPlotId) &&
            String(p.cropIdVal) === String(selectedCropId)
        );
        setVehicleOptions(filteredVehicleOptions);
      } else {
        setVehicleOptions([]);
      }
    }
  }, [selectedCropId, selectedPlotId, plots, isUpdateLoaded]);

  useEffect(() => {
    if (!props.update) {
      setIsUpdateLoaded(false);
    }
  }, [props.update]);

  useEffect(() => {
    // console.log("isUpdateLoaded:", isUpdateLoaded);
  }, [isUpdateLoaded]);

  useEffect(() => {
    // console.log("vehicleOptions:", vehicleOptions);
  }, [vehicleOptions]);

  useEffect(() => {
    if (selectedCropId && selectedPlotId) {
      fetchGoodIssueAmount(
        {
          url: `/api/farmerInvoiceGoodIssue/?orgId=${localStorage.getItem(
            "orgId"
          )}&cropId=${selectedCropId}&plotId=${selectedPlotId}`,
        },
        (res) => {
          // console.log(" good issueres",res)
          // console.log(" good issueres",res.totalInputAmount)
          if (res) {
            setGoodIssueAmount(res.totalInputAmount);
            setTotalGoodIssueAmount(res.totalAmount);
            setTotalAdministrativeAmount(res.totalAdministrativeAmount);
            setIssueProductResult(res.issueProductresult || []);
            setFarmerInputTemplateresult(res.farmerInputTemplateresult || []);
          }
          // if (res && Array.isArray(res)) {
          //   setGoodIssueAmount(res);
          // } else {
          //   setGoodIssueAmount([]);
          // }
        }
      );
    } else {
      setGoodIssueAmount(0);
    }
  }, [selectedCropId, selectedPlotId, fetchGoodIssueAmount]);

  useEffect(() => {
    if (selectedFarmerId) {
      fetchRanchesForFarmer(
        {
          url: `/api/ranchDetailById/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerId=${selectedFarmerId}`,
        },
        (res) => {
          if (res && Array.isArray(res)) {
            setFarmsRanches(res);
          } else {
            setFarmsRanches([]);
          }
        }
      );
    } else {
      setFarmsRanches([]);
    }
  }, [selectedFarmerId, fetchRanchesForFarmer]);

  const uniquePlots = Array.from(
    new Map(plots.map((plot) => [plot.plotIdVal, plot])).values()
  );

  useEffect(() => {
    if (selectedPlotId) {
      // Filter plots for the selected plotId
      const cropsForPlot = plots
        .filter((plot) => String(plot.plotIdVal) === String(selectedPlotId))
        .map((plot) => ({
          cropNameVal: plot.cropNameVal,
          cropIdVal: plot.cropIdVal,
        }));

      const uniqueCrops = Array.from(
        new Map(cropsForPlot.map((crop) => [crop.cropIdVal, crop])).values()
      );

      // setAvailableCrops(uniqueCrops);

      if (props.update && props.update.cropName) {
        const matchedCrop = uniqueCrops.find(
          (crop) => crop.cropNameVal === props.update.cropName
        );

        if (matchedCrop) {
          setCropName(matchedCrop.cropNameVal);
          setCropId(matchedCrop.cropIdVal);
          setSelectedCropId(matchedCrop.cropIdVal);
        } else {
          // fallback to first crop or clear if no match
          if (uniqueCrops.length > 0) {
            setCropName(uniqueCrops[0].cropNameVal);
            setCropId(uniqueCrops[0].cropIdVal);
            setSelectedCropId(uniqueCrops[0].cropIdVal);
          } else {
            setCropName("");
            setCropId("");
            setSelectedCropId("");
          }
        }
      }
    } else {
      // If no plot selected, clear crop related state
      setAvailableCrops([]);
      setCropName("");
      setCropId("");
      setSelectedCropId("");
    }
  }, [selectedPlotId, plots, props.update]);

  const onSelectFarmer = (farmer) => {
    setFarmerNo(farmer.farmerNo);
    setFarmerName(farmer.farmerName);
    setSelectedFarmerId(farmer.farmerId);
    setFarmerInput(farmer.farmerName + " (" + farmer.farmerNo + ")");
    setFieldExecutiveName(farmer.executiveName || "");
    setBankName(farmer.bankName || "");
    setAccountNumber(farmer.accountNumber || "");
    setIfscCode(farmer.ifscCode || "");
    setHolderName(farmer.accountHolderName || "");
    setShowSuggestions(false);
  };

  // useEffect(() => {
  //   if (props.update && props.update.ranchName) {
  //     setSelectedRanch(props.update.ranchName);
  //   }
  // }, [props.update]);

  const { sendRequest: putPlot } = useHttp();

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);

    return uniqueID.toString();
  }

  const submitHandler = async (e) => {
    e.preventDefault();

    const orgId = parseInt(localStorage.getItem("orgId"));
    const createdBy = parseInt(localStorage.getItem("id"));

    const totalAmountGood = optionsToUse
      .filter((x) => x.fruitQuality?.toLowerCase() === "good")
      .reduce((sum, x) => sum + (parseFloat(x.totalAmt) || 0), 0);

    const totalAmountBad = optionsToUse
      .filter((x) => x.fruitQuality?.toLowerCase() === "bad")
      .reduce((sum, x) => sum + (parseFloat(x.totalAmt) || 0), 0);

    const totalAmountVehicle = totalAmountGood + totalAmountBad;
    // console.log("totalAmountGood", totalAmountGood);
    // console.log("totalAmountBad", totalAmountBad);
    // console.log("totalAmountVehicle", totalAmountVehicle);

    // const finalAmount = totalAmountVehicle - totalGoodIssueAmount;

    const totalExpenseAmount = goodIssueAmount + totalAdministrativeAmount;

    let totalAmountGoodIssue = 0;
    if (goodIssueAmount && goodIssueAmount.length > 0) {
      totalAmountGoodIssue = goodIssueAmount.reduce((sum, item) => {
        if (
          String(item.cropId) === String(selectedCropId) &&
          String(item.plotId) === String(selectedPlotId)
        ) {
          return sum + (parseFloat(item.totalAmount) || 0);
        }
        return sum;
      }, 0);
    }

    const finalAmount = totalAmountVehicle - totalExpenseAmount;
    // console.log("totalAmountVehicle", totalAmountVehicle);
    // console.log("totalExpenseAmount", totalExpenseAmount);
    // console.log("finalAmount", finalAmount);

    const data = {
      invoiceId: props.update ? props.update.invoiceId : generateUniqueID(),
      invoiceDate: invoiceDate || null,
      farmerId: selectedFarmerId || null,
      cropId: selectedCropId || null,
      totalAmount: (finalAmount || 0).toFixed(2),
      orgId: orgId,
      createdBy: createdBy,
      goodsIssueAmount: totalExpenseAmount,
      bankName: bankName,
      accountNumber: accountNumber,
      accountHolderName: holderName,
      ifscCode: ifscCode,
      inputCost: goodIssueAmount,
      administrativeCost: totalAdministrativeAmount,
      baseRate: baseRate,
      bonusRate: bonusRate,
      scoreLimit: scoreLimit,
      farmerScore: farmerScore,
      farmerRate: farmerRate,
      farmerInvoiceProcurment: (props.update
        ? vehicleOptions1
        : vehicleOptions
      ).map((entry) => ({
        vehicleWeighBridgeFarmerId: entry.vehicleWeighBridgeFarmerId || null,
        // rate:( entry.RateKg && entry.RateKg > 0 ? entry.RateKg : farmerRate || 0),
        rate: (entry.fruitQuality === "Good" ? (entry.RateKg && entry.RateKg > 0 ? entry.RateKg : farmerRate || 0) : badRate),
        qtyAdjustmentPercentage: entry.QtyAdjustment || 0,
        finalQuantity: entry.FinalQuantity || 0,
        totalAmount: entry.totalAmt || 0,
      })),
    };

    // console.log("first")
    try {
      await putPlot(
        {
          url: "/api/farmerInvoice/",
          method: props.update ? "PUT" : "POST",
          body: data,
          headers: { "Content-Type": "application/json" },
        },
        (res) => {
          toast.success(
            `Farmer invoice Details ${props.update ? "Updated" : "Added"}`
          );
          props.addForm(false);
        }
      );
    } catch (error) {
      toast.error("Failed to submit farmer invoice");
      console.error("Submit error:", error);
    }
  };

  useEffect(() => {
    if (props.update && farmsRanches.length > 0) {
      const ranchExists = farmsRanches.some(
        (ranch) => String(ranch.ranchId) === String(props.update.ranchId)
      );
      if (ranchExists) {
        setSelectedRanchId(String(props.update.ranchId));
      }
    }
  }, [props.update, farmsRanches]);

  useEffect(() => {
    if (selectedFarmerId) {
      fetchRanchesForFarmer(
        {
          url: `/api/ranchDetailById/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerId=${selectedFarmerId}`,
        },
        (res) => {
          if (res && Array.isArray(res)) {
            setFarmsRanches(res);
          } else {
            setFarmsRanches([]);
          }
        }
      );
    } else {
      setFarmsRanches([]);
    }
  }, [selectedFarmerId, fetchRanchesForFarmer]);

  useEffect(() => {
    if (props.update) {
      setAllowCropAutofill(true);

      setSelectedFarmerId(props.update.farmerId);
      setFarmerNo(props.update.farmerNo || "");
      setFarmerName(props.update.farmerName || "");
      setFieldExecutiveName(props.update.executiveName || "");
      setSelectedPlotId(String(props.update.plotId));
      const selectedPlot = plots.find(
        (plot) => String(plot.plotIdVal) === String(props.update.plotId)
      );

      setPlotArea(selectedPlot?.plotArea || "");
      setPlotAreaUnit(selectedPlot?.plotAreaUnit || "");
      setBankName(props.update.bankName);
      setAccountNumber(props.update.accountNumber);
      setHolderName(props.update.accountHolderName);
      setIfscCode(props.update.ifscCode);
      const farmerNameValue = props.update.farmerName || "";
      const farmerNoValue = props.update.farmerNo || "";
      setFarmerInput(
        farmerNameValue || farmerNoValue
          ? `${farmerNameValue} (${farmerNoValue})`
          : ""
      );

      const cropsForPlot = plots
        .filter(
          (plot) => String(plot.plotIdVal) === String(props.update.plotId)
        )
        .map((plot) => ({
          cropNameVal: plot.cropNameVal,
          cropIdVal: plot.cropIdVal,
        }));
      const uniqueCrops = Array.from(
        new Map(cropsForPlot.map((crop) => [crop.cropIdVal, crop])).values()
      );
      setAvailableCrops(uniqueCrops);

      if (uniqueCrops.length > 0 && props.update.cropName) {
        const matchedCrop = uniqueCrops.find(
          (crop) => crop.cropNameVal === props.update.cropName
        );

        if (matchedCrop) {
          setCropName(matchedCrop.cropNameVal);
          setCropId(matchedCrop.cropIdVal);
          setSelectedCropId(matchedCrop.cropIdVal);

          const variety = plots.find(
            (p) =>
              String(p.plotIdVal) === String(props.update.plotId) &&
              String(p.cropIdVal) === String(matchedCrop.cropIdVal)
          );
          setVarietyName(variety?.varietyName || "");
          setVarietyId(variety?.varietyId || "");

          const filteredVehicleOptions = plots.filter(
            (p) =>
              String(p.plotIdVal) === String(props.update.plotId) &&
              String(p.cropIdVal) === String(matchedCrop.cropIdVal)
          );
          setVehicleOptions(filteredVehicleOptions);
        }
      }

      const parsedDate = props.update.invoiceDate
        ? moment(props.update.invoiceDate, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "";

      setInvoiceDate(parsedDate);
      setFieldExecutiveName(props.update.executiveName || "");

      if (Array.isArray(props.update.procurements)) {
        const mappedProcurments = props.update.procurements.map((item) => ({
          vehicleWeighBridgeFarmerId: item.vehicleWeighBridgeFarmerId || null,
          fruitQuality: item.fruitQuality || "",
          QtyAdjustment: item.qtyAdjustmentPercentage || 0,
          FinalQuantity: item.finalQuantity || 0,
          RateKg: item.rate || 0,
          totalAmt: item.totalAmount || 0,
          totalQuantity: item.totalQuantity || 0,
          docNo: item.docNo || "",
          harvstDate: item.harvstDate
            ? moment(item.harvstDate, moment.ISO_8601).format("DD/MM/YYYY")
            : "",
        }));
        setVehicleOptions1(mappedProcurments);
      }

      setIsUpdateLoaded(true);
    }
  }, [props.update, plots]);

  const handleQtyAdjustmentChange = (index, value) => {
    const list = props.update ? [...vehicleOptions1] : [...vehicleOptions];

    const qtyAdj = parseFloat(value) || 0;
    list[index].QtyAdjustment = qtyAdj;

    const totalQty = parseFloat(list[index].totalQuantity) || 0;
    const deducted = (totalQty * qtyAdj) / 100;

    list[index].FinalQuantity = totalQty - deducted;

    const rate =
      list[index].fruitQuality === "Good"
        ? (list[index].RateKg || farmerRate)
        : badRate;

    list[index].totalAmt = list[index].FinalQuantity * rate;

    props.update ? setVehicleOptions1(list) : setVehicleOptions(list);
  };


  const handleRateKgChange = (index, value) => {
    const newRate = parseFloat(value) || 0;
    // setFarmerRate(newRate); // update global farmerRate (or per row if implemented)
    if (props.update) {
      const newOptions = [...vehicleOptions1];
      newOptions[index].RateKg = newRate;
      const finalQty = parseFloat(newOptions[index].FinalQuantity) || 0;
      newOptions[index].totalAmt = finalQty * newRate;
      setVehicleOptions1(newOptions);
    } else {
      const newOptions = [...vehicleOptions];
      newOptions[index].RateKg = newRate;
      const finalQty = parseFloat(newOptions[index].FinalQuantity) || 0;
      newOptions[index].totalAmt = finalQty * newRate;
      setVehicleOptions(newOptions);
    }
  };

  // const handleRateKgChange = (index, value) => {
  //   if (props.update) {
  //     const newOptions = [...vehicleOptions1];
  //     const rate = parseFloat(value);
  //     newOptions[index].RateKg = isNaN(rate) ? 0 : rate;

  //     const finalQty = parseFloat(newOptions[index].FinalQuantity) || 0;
  //     newOptions[index].totalAmt = finalQty * newOptions[index].RateKg;

  //     setVehicleOptions(newOptions);
  //   } else {
  //     const newOptions = [...vehicleOptions];
  //     const rate = parseFloat(value);
  //     newOptions[index].RateKg = isNaN(rate) ? 0 : rate;

  //     const finalQty = parseFloat(newOptions[index].FinalQuantity) || 0;
  //     newOptions[index].totalAmt = finalQty * newOptions[index].RateKg;

  //     setVehicleOptions(newOptions);
  //   }
  // };

  const optionsToUse = props.update ? vehicleOptions1 : vehicleOptions;
  const canSubmit = optionsToUse && optionsToUse.length > 0;

  const totalAmountGood = optionsToUse
    .filter((x) => x.fruitQuality?.toLowerCase() === "good")
    .reduce((sum, x) => sum + (parseFloat(x.totalAmt) || 0), 0);

  const totalAmountBad = optionsToUse
    .filter((x) => x.fruitQuality?.toLowerCase() === "bad")
    .reduce((sum, x) => sum + (parseFloat(x.totalAmt) || 0), 0);

  const totalAmountVehicle = totalAmountGood + totalAmountBad;

  const totalExpenseAmount = goodIssueAmount + totalAdministrativeAmount;

  let totalAmountGoodIssue = 0;
  if (goodIssueAmount && goodIssueAmount.length > 0) {
    totalAmountGoodIssue = goodIssueAmount.reduce((sum, item) => {
      if (
        String(item.cropId) === String(selectedCropId) &&
        String(item.plotId) === String(selectedPlotId)
      ) {
        return sum + (parseFloat(item.totalAmount) || 0);
      }
      return sum;
    }, 0);
  }

  const finalAmount = totalAmountVehicle - totalExpenseAmount;

  useEffect(() => {
    if (
      baseRate !== "" &&
      bonusRate !== "" &&
      scoreLimit !== "" &&
      farmerScore !== ""
    ) {
      let rate = parseFloat(baseRate) || 0;
      const bonus = parseFloat(bonusRate) || 0;
      const score = parseFloat(farmerScore) || 0;
      const limit = parseFloat(scoreLimit) || 0;

      if (score < limit) {
        rate = baseRate;
      } else {
        const bonusPercentage = (bonus * score) / 100;
        rate = rate + bonusPercentage;
      }

      setFarmerRate(rate);
    }
  }, [baseRate, bonusRate, scoreLimit, farmerScore]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Farmer Invoice</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Farmer Invoice Date</label>
                        <input
                          type="date"
                          required
                          className="form-control"
                          value={invoiceDate}
                          onChange={(e) => setInvoiceDate(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-3" style={{ position: "relative" }}>
                      <div className="form-group">
                        <label>Farmer No</label>
                        <input
                          type="text"
                          className="form-control"
                          value={farmerInput}
                          placeholder="Farmer No..."
                          disabled={props.update}
                          required
                          onChange={(e) => {
                            const inputVal = e.target.value;
                            setFarmerInput(inputVal);
                            setFarmerNo(inputVal);

                            const filtered = inputVal
                              ? farmerList.filter((farmer) =>
                                (farmer.farmerName + " (" + farmer.farmerNo + ")")
                                  .toLowerCase()
                                  .includes(inputVal.toLowerCase())
                              )
                              : farmerList;

                            setFilteredFarmers(filtered);
                            setShowSuggestions(true);
                          }}
                          onBlur={() => setTimeout(() => setShowSuggestions(false), 100)}
                          onFocus={() => {
                            const list = farmerInput
                              ? filteredFarmers
                              : farmerList;

                            setFilteredFarmers(list);
                            setShowSuggestions(true);
                          }}
                        />


                        {showSuggestions && filteredFarmers.length > 0 && (
                          <ul
                            style={{
                              listStyleType: "none",
                              margin: 0,
                              padding: 0,
                              border: "1px solid #ccc",
                              borderTop: "none",
                              maxHeight: "180px",
                              overflowY: "auto",
                              position: "absolute",
                              width: "100%",
                              backgroundColor: "white",
                              zIndex: 1000,
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            {filteredFarmers.map((farmer) => (
                              <li
                                key={farmer.farmerId}
                                onClick={() => onSelectFarmer(farmer)}
                                onMouseDown={(e) => e.preventDefault()}
                                style={{ padding: "6px 10px", cursor: "pointer" }}
                              >
                                {`${farmer.farmerName} ( ${farmer.farmerNo} )`}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Field Executive Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fieldExecutiveName}
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Ranch Name</label>
                        <select
                          className="form-control"
                          value={selectedRanchId}
                          disabled={props.update}
                          required
                          onChange={(e) => setSelectedRanchId(e.target.value)}
                        // ref={(el) => (frmRef.current["ranchName"] = el)}
                        >
                          <option value="">Select Ranch</option>
                          {farmsRanches.map((ranch) => (
                            <option
                              key={ranch.ranchId || ranch.id}
                              value={ranch.ranchId}
                            >
                              {ranch.ranchName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Plot Name</label>
                        <select
                          className="form-control"
                          value={selectedPlotId}
                          disabled={props.update}
                          required
                          onChange={(e) => {
                            const plotId = e.target.value;
                            setSelectedPlotId(plotId);

                            const selectedPlot = plots.find(
                              (plot) =>
                                String(plot.plotIdVal) === String(plotId)
                            );

                            if (selectedPlot) {
                              setPlotArea(selectedPlot.plotArea || "");
                              setPlotAreaUnit(selectedPlot.plotAreaUnit || "");

                              const cropsForPlot = plots
                                .filter(
                                  (plot) =>
                                    String(plot.plotIdVal) === String(plotId)
                                )
                                .map((plot) => ({
                                  cropNameVal: plot.cropNameVal,
                                  cropIdVal: plot.cropIdVal,
                                }));

                              const uniqueCrops = Array.from(
                                new Map(
                                  cropsForPlot.map((crop) => [
                                    crop.cropIdVal,
                                    crop,
                                  ])
                                ).values()
                              );

                              setAvailableCrops(uniqueCrops);

                              if (uniqueCrops.length > 0) {
                                if (
                                  allowCropAutofill &&
                                  props.update?.cropName
                                ) {
                                  const matchedCrop = uniqueCrops.find(
                                    (crop) =>
                                      crop.cropNameVal === props.update.cropName
                                  );

                                  if (matchedCrop) {
                                    setCropName(matchedCrop.cropNameVal);
                                    setCropId(matchedCrop.cropIdVal);
                                    setSelectedCropId(matchedCrop.cropIdVal);

                                    const variety = plots.find(
                                      (p) =>
                                        String(p.plotIdVal) ===
                                        String(plotId) &&
                                        String(p.cropIdVal) ===
                                        String(matchedCrop.cropIdVal)
                                    );

                                    setVarietyName(variety?.varietyName || "");
                                    setVarietyId(variety?.varietyId || "");

                                    const filteredVehicleOptions = plots.filter(
                                      (p) =>
                                        String(p.plotIdVal) ===
                                        String(plotId) &&
                                        String(p.cropIdVal) ===
                                        String(matchedCrop.cropIdVal)
                                    );
                                    setVehicleOptions(filteredVehicleOptions);
                                  }
                                } else {
                                  // clear crop selection when user manually changes plot
                                  setCropName("");
                                  setCropId("");
                                  setSelectedCropId("");
                                  setVarietyName("");
                                  setVarietyId("");
                                  setVehicleOptions([]);
                                }

                                // reset flag after first use
                                setAllowCropAutofill(false);
                              }
                            }
                          }}
                        >
                          <option value="">Select Plot</option>
                          {uniquePlots.map((plot) => (
                            <option key={plot.plotIdVal} value={plot.plotIdVal}>
                              {plot.plotName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Plot Area</label>
                        <input
                          type="text"
                          className="form-control"
                          value={plotArea}
                          readOnly
                          placeholder="Plot Area"
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Unit</label>
                        <input
                          type="text"
                          className="form-control"
                          value={plotAreaUnit}
                          readOnly
                          placeholder="Unit"
                        />
                      </div>
                    </div>
                    {/* <h5 style={{ paddingTop: "35px" }}>Unit</h5> */}

                    <div className="col-md-2" style={{ marginLeft: "20px" }}>
                      <div className="form-group">
                        <label>Crop Name</label>
                        <select
                          className="form-control"
                          value={cropName}
                          disabled={props.update}
                          required
                          onChange={(e) => {
                            const selectedCrop = availableCrops.find(
                              (c) => c.cropNameVal === e.target.value
                            );
                            if (selectedCrop) {
                              setCropName(selectedCrop.cropNameVal);
                              setCropId(selectedCrop.cropIdVal);
                              setSelectedCropId(selectedCrop.cropIdVal);

                              const variety = plots.find(
                                (p) =>
                                  p.plotIdVal === parseInt(selectedPlotId) &&
                                  p.cropIdVal === selectedCrop.cropIdVal
                              );

                              setVarietyName(variety?.varietyName || "");
                              setVarietyId(variety?.varietyId || "");
                              setSelectedCropId(selectedCrop.cropIdVal);

                              const filteredVehicleOptions = plots.filter(
                                (p) =>
                                  String(p.plotIdVal) ===
                                  String(selectedPlotId) &&
                                  String(p.cropIdVal) ===
                                  String(selectedCrop.cropIdVal)
                              );
                              setVehicleOptions(filteredVehicleOptions);
                            }
                          }}
                        >
                          <option value="">Select Crop</option>
                          {availableCrops.map((crop) => (
                            <option
                              key={crop.cropIdVal}
                              value={crop.cropNameVal}
                            >
                              {crop.cropNameVal}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2" style={{ marginLeft: "20px" }}>
                      {/* <div className="form-group">
                        <label>Variety Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={varietyName}
                          readOnly
                          placeholder="Crop Variety"
                        />
                      </div> */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-2">

                      <div className="form-group">
                        <label>Bad Rate</label>
                        <input
                          type="text"
                          className="form-control"
                          value={badRate}
                          readOnly
                          placeholder="Bad Rate"
                        />
                      </div>



                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Good/Base Rate</label>
                        <input
                          type="text"
                          className="form-control"
                          value={baseRate}
                          readOnly
                          placeholder="Good/Base Rate"
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Bonus Rate</label>
                        <input
                          type="text"
                          className="form-control"
                          value={bonusRate}
                          readOnly
                          placeholder="Bonus Rate"
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Score Limit</label>
                        <input
                          type="text"
                          className="form-control"
                          value={scoreLimit}
                          readOnly
                          placeholder="Score Limit"
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Farmer Score</label>
                        <input
                          type="text"
                          className="form-control"
                          value={farmerScore}
                          readOnly
                          placeholder="Farmer Score"
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label>Farmer Rate</label>
                        <input
                          type="text"
                          className="form-control"
                          value={farmerRate}
                          readOnly
                          placeholder="Farmer Rate"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Sr. No</th>
                          <th>Doc No.</th>
                          <th>Date</th>
                          <th>Total Qty</th>
                          <th>Quality</th>
                          <th>Qty Adjustment(%)</th>
                          <th>Final Quantity</th>
                          <th>Rate/Kg</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(props.update ? vehicleOptions1 : vehicleOptions)?.map(
                          (x, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{x.docNo}</td>
                              {/* <td>{x.harvstDate}</td> */}
                              <td>{x.harvstDate}</td>
                              <td>{x.totalQuantity}</td>
                              <td>{x.fruitQuality}</td>
                              <td>
                                <input
                                  className="form-control"
                                  type="text"
                                  defaultValue={x.QtyAdjustment || 0}
                                  onChange={(e) =>
                                    handleQtyAdjustmentChange(i, e.target.value)
                                  }
                                  required
                                  style={{ width: "130px" }}
                                />
                              </td>
                              <td>{parseFloat(x.FinalQuantity).toFixed(2)}</td>
                              <td>
                                <input
                                  className="form-control"
                                  type="number"
                                  // defaultValue={x.RateKg}
                                  // onChange={(e) =>
                                  //   handleRateKgChange(i, e.target.value)
                                  // }
                                  value={x.fruitQuality == "Good" ? farmerRate : badRate}
                                  onChange={(e) =>
                                    handleRateKgChange(i, e.target.value)
                                  }
                                  required
                                  style={{ width: "100px" }}
                                />
                              </td>
                              <td>{formatNumber(
                                parseFloat(x.totalAmt) == 0 ? (parseFloat(x.FinalQuantity) * parseFloat((x.fruitQuality == "Good" ? farmerRate : badRate))) : x.totalAmt
                              )}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                    {/* <div style={{ marginTop: "30px" }}> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between", // pushes to edges
                        alignItems: "flex-start",
                        width: "100%",
                        marginBottom: "20px",
                      }}
                    >
                      {/* Left Table: Bank Details */}
                      <div style={{ flex: "1", maxWidth: "46%" }}>
                        <table
                          border="1"
                          cellPadding="10"
                          cellSpacing="0"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                          }}
                        >
                          <thead>
                            <tr>
                              <th colSpan="2" style={{ textAlign: "center" }}>
                                Bank Details
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                Account Holder Name
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={holderName}
                                  onChange={(e) => {
                                    setHolderName(e.target.value);
                                  }}
                                  placeholder="Account Holder Name"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                Account Number
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={accountNumber}
                                  onChange={(e) => {
                                    setAccountNumber(e.target.value);
                                  }}
                                  placeholder="Account Number"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>Bank Name</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={bankName}
                                  onChange={(e) => {
                                    setBankName(e.target.value);
                                  }}
                                  placeholder="Bank Name"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>IFSC Code</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={ifscCode}
                                  onChange={(e) => {
                                    setIfscCode(e.target.value);
                                  }}
                                  placeholder="IFSC Code"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Right Table: Financial Summary */}
                      <div
                        style={{
                          flex: "1",
                          maxWidth: "46%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <table
                          border="1"
                          cellPadding="10"
                          cellSpacing="0"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                          }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                A. Total Amount (Good)
                              </td>
                              <td>{formatNumber(totalAmountGood.toFixed(2))}</td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                B. Total Amount (Bad)
                              </td>
                              <td>{formatNumber(totalAmountBad.toFixed(2))}</td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                C. Total Amount (A+B)
                              </td>
                              <td>{formatNumber(totalAmountVehicle.toFixed(2))}</td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                D. Input Cost
                                {goodIssueAmount > 0 &&
                                  issueProductResult.length > 0 && (
                                    <table
                                      className="table table-sm table-bordered mt-2 mb-0"
                                      style={{ fontSize: "12px" }}
                                    >
                                      <thead>
                                        <tr>
                                          <th>Product</th>
                                          <th>Qty</th>
                                          <th>Amt</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {issueProductResult.map((item, idx) => (
                                          <tr key={idx}>
                                            <td>{item.productName}</td>
                                            <td>
                                              {item.useQty.toFixed(2)}{" "}
                                              {item.unitAbbreviation || ""}
                                            </td>
                                            <td>{formatNumber(item.useAmt.toFixed(2))}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  )}
                              </td>
                              <td>{goodIssueAmount.toFixed(2)}</td>
                            </tr>

                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                E. Administrative Cost
                                {farmerInputTemplateresult.length > 0 && (
                                  <table
                                    className="table table-sm table-bordered mt-2 mb-0"
                                    style={{ fontSize: "12px" }}
                                  >
                                    <thead>
                                      <tr>
                                        <th>Total Cost Farmer</th>
                                        <th>Plot Area</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {farmerInputTemplateresult.map(
                                        (item, idx) => (
                                          <tr key={idx}>
                                            <td>{formatNumber(item.totalCostFarmer)}</td>
                                            <td>{item.plotArea}</td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                )}
                              </td>
                              <td>{formatNumber(totalAdministrativeAmount.toFixed(2))}</td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                F. Total Expense Amount (D+E)
                              </td>
                              <td>{formatNumber(totalExpenseAmount.toFixed(2))}</td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>
                                Final Amount (C-F)
                              </td>
                              <td>{formatNumber(finalAmount.toFixed(2))}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={!canSubmit}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default FarmerInvoiceForm;
